import { render, staticRenderFns } from "./d-activity-avatar.vue?vue&type=template&id=6b4cf85f&scoped=true&"
import script from "./d-activity-avatar.vue?vue&type=script&lang=js&"
export * from "./d-activity-avatar.vue?vue&type=script&lang=js&"
import style0 from "./d-activity-avatar.vue?vue&type=style&index=0&id=6b4cf85f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4cf85f",
  null
  
)

export default component.exports